/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Create_SuccessInputs */

const en_case_create_success = /** @type {(inputs: Case_Create_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Case created successfully`)
};

const pt_br2_case_create_success = /** @type {(inputs: Case_Create_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caso criado com sucesso`)
};

/**
* | output |
* | --- |
* | "Case created successfully" |
*
* @param {Case_Create_SuccessInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_create_success = /** @type {((inputs?: Case_Create_SuccessInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Create_SuccessInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_create_success(inputs)
	return pt_br2_case_create_success(inputs)
});